import { BANK_PAYMENT_REQUEST, CREATE_BANK_PAYMENT, GET_BANK_PAYMENTS, UPDATE_BANK_PAYMENT, DELETE_BANK_PAYMENT,
  BANK_PAYMENT_REQUEST_FAILURE, BANK_PAYMENT_REQUEST_SUCCESS, GET_BANK_PAYMENTS_PAGE } from '../types';

const initialState = {
  bankPayments: [],
  bankPaymentsPage: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const bankPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case BANK_PAYMENT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_BANK_PAYMENTS: {
      return {
        ...state,
        bankPayments: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_BANK_PAYMENTS_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        bankPaymentsPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_BANK_PAYMENT: {
      return {
        ...state,
        bankPayments: [action.payload, ...state.bankPayments],
        loading: false,
        error: null
      };
    }
    case UPDATE_BANK_PAYMENT: {
      const bankPaymentsData = state.bankPayments.slice(0);
      const uIndex = bankPaymentsData.findIndex((data) => data.id === action.payload.id);
      bankPaymentsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        bankPayments: [ ...bankPaymentsData ],
        loading: false,
        error: null
      };
    }
    case DELETE_BANK_PAYMENT: {
      const bankPayments = state.bankPayments?.slice(0);
      const index = bankPayments.findIndex((data) => data.id === action.id);
      if (index > -1) {
        bankPayments.splice(index, 1);
      }
      return {
        ...state,
        bankPayments: [...bankPayments],
        loading: false,
        error: null
      }
    }
    case BANK_PAYMENT_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case BANK_PAYMENT_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default bankPaymentReducer;